;(function (angular, _) {
  'use strict'

  class ProductMultipleEditController {
    constructor (
    // Angular
      $q,
      // Libs
      // Managers
      ProductManager, ProductTypeManager, BpuManager, ClientConditionManager,
      // Services
      PreferencesService, SessionService, EntityService, CategoryService
    // Const
    // Resolved
    ) {
      this.$q = $q
      this.productManager = ProductManager
      this.productTypeManager = ProductTypeManager
      this.preferencesService = PreferencesService
      this.sessionService = SessionService
      this.bpuManager = BpuManager
      this.categoryService = CategoryService
      this.clientConditionManager = ClientConditionManager
      this.entityService = EntityService
      this.saveCategory = false

      this.init()
    }

    init () {
      this.categories = []
      this.categoriesLoaded = false
      this.getCategories()
    }

    searchVats () {
      this.preferencesService.getCompanyPrefs().then((prefs) => {
        this.vats = prefs.vats
      })
    }
    searchTypes () {
      this.productTypeManager.getAllByBatch(this.productTypeManager.query()).then((data) => {
        this.types = data.data
      })
    }

    searchBpu (search) {
      let query = this.bpuManager.query({
        populate: JSON.stringify([
          {
            path: 'client'
          }
        ])
      })
        .search(search, 'label')
      return this.bpuManager.get(query)
        .then((data) => {
          this.bpus = data.data
          return data.data
        })
    }

    getCategories () {
      return this.categoryService.getCategories().then((data) => {
        this.categories = data.map(category => category.label)
        this.categoriesLoaded = true
        return this.categories
      })
    }

    searchCategories (search) {
      let newCategories = this.categories.slice()
      if (search && newCategories.indexOf(search) === -1) {
        newCategories.unshift(search)
      }
      return newCategories
    }

    categoryExists () {
      return this.categories.includes(this.value)
    }
  }

  ProductMultipleEditController.$inject = [
    // Angular
    '$q',
    // Libs
    // Managers
    'ProductManager', 'ProductTypeManager', 'BpuManager', 'ClientConditionManager',
    // Services
    'PreferencesService', 'SessionService', 'EntityService', 'CategoryService'
    // Const
    // Resolved
  ]

  angular.module('kilo.common.components')
    .component('productMultipleEdit', {
      templateUrl: '/app/common/components/product-multiple-edit/product-multiple-edit.template.html',
      bindings: {
        type: '=',
        value: '=',
        saveCategory: '='

      },
      controller: ProductMultipleEditController
    })
})(window.angular, window._)
